
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activate/retail",
      function () {
        return require("private-next-pages/activate/retail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activate/retail"])
      });
    }
  